<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="invokeMethod($event)" :add-list="addList" perm="configuration.update"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetManufacturer()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="manufacturer != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip right :disabled="!hasPerm('configuration.update')">
                                        <template slot="activator">
                                            <v-btn
                                                v-if="hasPerm('configuration.update')"
                                                style="max-width: 120px; text-transform: none"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="manufacturer.status_class"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="manufacturer.status">{{
                                                    status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"
                                                }}</v-icon>
                                                <span class="white--text">{{
                                                    status_loader ? $t("lang.loading") : manufacturer.status == "1" ? $t("lang.active") : $t("lang.disabled")
                                                }}</span>
                                            </v-btn>
                                            <v-chip
                                                v-else
                                                disabled
                                                round
                                                text-color="white"
                                                class="chip-padding-left-4 mr-auto fs-14"
                                                :color="manufacturer.status_class"
                                            >
                                                <span><v-icon class="mr-2">check_circle</v-icon></span>
                                                <span class="white--text">{{ manufacturer.status == "1" ? $t("lang.active") : $t("lang.disabled") }}</span>
                                            </v-chip>
                                        </template>
                                        {{ manufacturer.status == "0" ? $t("lang.click_to_activate") : $t("lang.click_to_deactivate") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <div class="ml-auto">
                                        <bc-tooltip perm="configuration.update">
                                            <template slot="activator">
                                                <v-btn @mouseup.left="openCompanyModal()" icon>
                                                    <v-icon color="indigo">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.edit_manufacturer") }}
                                        </bc-tooltip>
                                    </div>
                                </v-flex>
                                <v-flex xs12 py-0 :class="{ 'prevent-click': !hasPerm('configuration.update') }">
                                    <bc-tooltip top>
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg ? errorImg : manufacturer.logo"
                                                height="150px"
                                                width="150px"
                                                class="rounded-circle mx-auto clickable"
                                                @mouseup.left="$refs.croppa.chooseFile()"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t("lang.uploadImage") }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex py-1>
                                    <p class="display-1 mb-0 text-xs-center">{{ manufacturer.company }}</p>
                                    <a class="display-0 mb-0 text-xs-center" :href="'http://' + manufacturer.website" target="_blank">{{
                                        manufacturer.website
                                    }}</a>
                                </v-flex>
                            </v-layout>
                            <v-divider v-if="entity_phones" class="my-0"></v-divider>
                            <bc-list
                                v-if="entity_phones"
                                :items="entity_phones"
                                prepend-icon="phone"
                                perm="configuration.update"
                                @invoke-method="showPhone($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="entity_addresses" class="my-0"></v-divider>
                            <bc-list
                                v-if="entity_addresses"
                                :items="entity_addresses"
                                prepend-icon="location_on"
                                perm="configuration.update"
                                @invoke-method="showAddress($event)"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ $t(`lang.${data.item.address_type}`) }}</v-flex>
                                    <v-flex list-sub>{{ data.item.address1 }}</v-flex>
                                    <v-flex list-sub>{{ `${data.item.city}, ${data.item.state} ${data.item.zip_code}` }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" perm="configuration.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.account_number")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ manufacturer.account_number || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.correspondence_method")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{
                                                manufacturer.correspondence_method ? $t(`lang.${manufacturer.correspondence_method}`) : "---"
                                            }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.currency_code")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ manufacturer.currency_code || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.payment_terms")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ manufacturer.payment_terms_description || "---" }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.has_nda")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ manufacturer.has_nda == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs8 mt-1>{{ `${$t("lang.has_contract")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ manufacturer.has_contract == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="description" perm="configuration.update" @invoke-method="openCompanyModal">
                                <template>
                                    <v-flex title>{{ $t("lang.notes") }}</v-flex>
                                    <v-flex style="white-space: pre-line">{{
                                        manufacturer.notes ? manufacturer.notes : $t("lang.none") | shrink_text(250)
                                    }}</v-flex>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <bc-tabs
                                    :tabs="subComponents"
                                    :selectedComponent="selectComponent(selectedComponent)"
                                    @button="$nextTick(() => (selectedComponent = $event))"
                                    :update-params="true"
                                >
                                </bc-tabs>
                                <v-card elevation="0" :key="refresh">
                                    <keep-alive>
                                        <component v-if="subComponentsMap[selectedComponent]" :is="component" class="tab"></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>

        <bc-dialog :value="manufacturer_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.edit_manufacturer") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="manufacturer_dialog"
                        :dialog-status="manufacturer_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formManufacturer">
                        <v-container pa-0 grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 column>
                                    <v-text-field
                                        v-model="manufacturer.company"
                                        :label="$t('lang.company')"
                                        :counter="showCounter(manufacturer.company, 'manufacturer.company')"
                                        :rules="ifValid('manufacturers.company')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="manufacturer.account_number"
                                        :label="$t('lang.account_number')"
                                        :counter="showCounter(manufacturer.account_number, 'manufacturer.account_number')"
                                        :rules="ifValid('manufacturers.account_number')"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="manufacturer.website"
                                        :label="$t('lang.website')"
                                        :counter="showCounter(manufacturer.website, 'manufacturer.website')"
                                        :rules="ifValid('manufacturers.website')"
                                    ></v-text-field>
                                    <bc-autocomplete
                                        v-model="manufacturer.payment_term_id"
                                        :label="$t('lang.payment_terms')"
                                        :items="payment_terms"
                                        item-value="payment_term_id"
                                        item-text="description"
                                        :rules="ifValid('manufacturers.payment_term_id')"
                                    ></bc-autocomplete>
                                    <bc-autocomplete
                                        v-model="manufacturer.currency_id"
                                        :label="$t('lang.currency_id')"
                                        :items="currencies"
                                        item-value="currency_id"
                                        item-text="name"
                                        :rules="ifValid('manufacturers.currency_id')"
                                    ></bc-autocomplete>
                                    <v-textarea v-model="manufacturer.notes" :label="$t('lang.notes')" auto-grow rows="1" :key="growText"></v-textarea>
                                </v-flex>
                                <v-flex xs12 sm6 column align-self-start>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_nda") }}</span>
                                    <v-switch
                                        v-model="manufacturer.has_nda"
                                        :label="manufacturer.has_nda == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.has_contract") }}</span>
                                    <v-switch
                                        v-model="manufacturer.has_contract"
                                        :label="manufacturer.has_contract == '1' ? $t('lang.yes') : $t('lang.no')"
                                        true-value="1"
                                        false-value="0"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                    <span class="fs-12 grey-label">{{ $t("lang.correspondence_method") }}</span>
                                    <v-switch
                                        v-model="manufacturer.correspondence_method"
                                        :label="manufacturer.correspondence_method == 'electronic' ? $t('lang.electronic') : $t('lang.mail')"
                                        true-value="electronic"
                                        false-value="mail"
                                        ripple
                                        class="no-margin mt-0 mb-4 pb-1"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="manufacturer_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="saveManufacturers()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-file-upload ref="croppa" :upload-function="handleFileUpload"></bc-file-upload>
        <bc-phone-dialog
            ref="phoneDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="manufacturer.entity_phones || []"
            :scope="manufacturer.scope"
            @eventname="updatePhones"
        ></bc-phone-dialog>
        <bc-address-dialog
            ref="addressDialog"
            object_ref="companies"
            :object_id="$route.params.id"
            :total_items="manufacturer.entity_addresses || []"
            :scope="manufacturer.scope"
            @eventname="updateAddresses"
        ></bc-address-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

import { manufacturerProfileComponents } from "Modules/companies/manufacturers/components/profile.data.js";

export default {
    data() {
        return {
            subComponentsMap: {},
            subComponents: manufacturerProfileComponents,
            selectedComponent: "shipments",
            component: null,
            tabs: [{ title: "shipments", name: "Shipments" }],
            validPhone: false,
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbGetManufacturer: _.debounce(this.getManufacturer, 1500, { maxWait: 1500, leading: true, trailing: false }),
            addList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", icon: "phone" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", icon: "location_on" },
            ],
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", perms: ["configuration.update"] },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", perms: ["configuration.update"] },
                { title: this.$t("lang.refresh"), action: "dbGetManufacturer" },
            ],
            manufacturer_dialog: false,
            manufacturer: {
                company: "",
                website: "",
                notes: "",
                logo: "",
                payment_term_id: "",
            },
            status_loader: false,
            file: "",
            newFile: {
                logo_file: "",
            },
            growText: 0,
            updatePhoto: 0,
            refresh: 0,
            errorImg: AppConfig.defaultProfileLogo,
            showErrorImg: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchManufacturer", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.manufacturer) {
                        this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "manufacturers", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchManufacturer", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.manufacturer) {
                        next((vm) => {
                            vm.manufacturer = vm.assignObj2(data.manufacturer, vm.rules_manufacturers);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "manufacturers", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_manufacturers: (state) => state.manufacturers.rules_manufacturers,
            profile: (state) => state.manufacturers.manufacturer,
            entity_addresses: (state) => state.manufacturers.entity_addresses,
            entity_phones: (state) => state.manufacturers.entity_phones,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            options: (state) => state.options.options,
        }),
    },
    created() {
        this.registerComponents();
    },
    methods: {
        ...mapActions([
            "fetchManufacturer",
            "saveManufacturer",
            "deleteManufacturer",
            "printManufacturer",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchOptions",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        registerComponents() {
            this.subComponents.forEach((cData) => {
                cData.import().then((component) => {
                    this.$set(this.subComponentsMap, cData.name, component.default);
                });
            });
        },
        selectComponent(componentName) {
            this.component = this.subComponentsMap[componentName];
        },
        getManufacturer(pg_refresh = false) {
            this.startLoader();

            this.fetchManufacturer({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.manufacturer) {
                    this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        saveManufacturers() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formManufacturer")) {
                    let body = this.prepForm(this.manufacturer, this.rules_manufacturers);

                    this.saveManufacturer({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.manufacturer) {
                            this.validationOff();
                            this.manufacturer_dialog = false;
                        }
                        this.toggleModalLoader(false);
                    });
                }
            });
        },
        changeStatus() {
            this.status_loader = true;
            let status = this.manufacturer.status == 1 ? 0 : 1;
            let body = { company_id: `${this.$route.params.id}`, status: status };

            this.saveManufacturer({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.manufacturer) {
                    this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                    this.status_loader = false;
                    this.finishLoader();
                }
            });
        },
        handleFileUpload(file) {
            this.toggleModalLoader(true);

            let body = { company_id: `${this.$route.params.id}`, logo_file: file };

            this.saveManufacturer({
                body: body,
            })
                .then((data) => {
                    if (typeof data != "undefined" && data.manufacturer) {
                        this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                        this.status_loader = false;
                        this.finishLoader();
                    }
                })
                .finally(() => {
                    this.toggleModalLoader(false);
                    this.$root.$emit("escapePressed");
                    this.$nextTick(() => {
                        this.updatePhoto++;
                    });
                });
        },

        async openCompanyModal() {
            this.manufacturer_dialog = true;
            this.growText++;

            if (this.payment_terms.length == 0) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.currencies.length == 0) await this.fetchCurrencies({ body: { options: 1, with_trashed: 1 } });
        },
        updateAddresses(addresses) {
            this.customer.entity_addresses = addresses;
        },
        updatePhones(phones) {
            this.customer.entity_phones = phones;
        },
        showAddress(item) {
            if (item) this.$refs.addressDialog.showAddress(item);
        },
        showPhone(item) {
            if (item) this.$refs.phoneDialog.showPhone(item);
        },
    },
};
</script>
